import React from "react";
import moment from "moment";
import PropTypes from "prop-types";

import Tooltip from "components/Tooltip";
import Translate from "utils/translate";

import styles from "./Timestamp.css";

const { t } = new Translate("Timestamp");

const Timestamp = ({ createdAt, original, updatedAt }) => {
  if (!createdAt && !updatedAt && !original) return null;

  const createdAtMoment = moment(createdAt);
  const updatedAtMoment = updatedAt && moment(updatedAt);
  const originalMoment = original && moment(original);

  return (
    <div className={styles.root}>
      {originalMoment ? (
        <div className={styles.original}>
          <Tooltip tip={originalMoment.format("L")} tooltip={t("original")} />
        </div>
      ) : (
        <>
          <Tooltip tip={createdAtMoment.fromNow()} tooltip={createdAtMoment.format("L - HH:mm")} />
          {updatedAtMoment && updatedAtMoment.isAfter(createdAtMoment) && (
            <div>
              <Tooltip tip={t("edited")} tooltip={updatedAtMoment.format("L - HH:mm")} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

Timestamp.propTypes = {
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  original: PropTypes.string,
};

export default Timestamp;
